var $ = require('jquery');
require('../web/jquery.googlemap');


/*define([
 'jquery',
 'web/jquery.gm'
 ], function($){*/
//"use strict";

window.web = window.web || {};
var web = window.web;

web.googlemaps = web.googlemaps || {};
web.googlemaps.activeMarker = null;

// listeners on google markers
web.googlemaps.loadMarkersListeners = {
    /*mouseover: function(e, data, marker) {
     // make marker grey
     var newIcon = $.extend(true, {}, marker.icon);
     newIcon.origin.x = 0;
     marker.setIcon(newIcon);
     },
     mouseout: function(e, data, marker) {
     //make marker violet again, if it wasn't clicked
     if (!marker.active) {
     var newIcon = $.extend(true, {}, marker.icon);
     newIcon.origin.x = 55;
     marker.setIcon(newIcon);
     }
     },*/

    click: function(e, data, marker) {
        var $card = $('.googleMapCard', $(marker.container).parent());
        var newIcon;
        // clicking on inactive marker
        if (!marker.active) {
            // set marker color>
            newIcon = $.extend(true, {}, marker.icon);
            newIcon.origin.x = 0;
            marker.setIcon(newIcon);

            // inactivate previously activated marker
            if (web.googlemaps.activeMarker) {
                web.googlemaps.activeMarker.active = false;
                var activeMarkerIcon = $.extend(true, {}, web.googlemaps.activeMarker.icon);
                activeMarkerIcon.origin.x = 55;
                web.googlemaps.activeMarker.setIcon(activeMarkerIcon);
                web.googlemaps.activeMarker = null;
            }
            // set current marker active - do not bother with icon style, it is handled by mouseover function - you can't click marker without hovering it
            marker.active = true;
            web.googlemaps.activeMarker = marker;

            // render custom bubble
            $card.html(web.googlemaps.createCard(data)).show();
        } else {
            // set marker color back
            newIcon = $.extend(true, {}, marker.icon);
            newIcon.origin.x = 55;
            marker.setIcon(newIcon);

            // clicking on active marker, cancel bubble and get rid of gray color - handled by mouseout
            marker.active = false;
            web.googlemaps.activeMarker = null;
            $card.empty().hide();
        }
    }
};

// create googlemap card
web.googlemaps.createCard = function(data) {
    var str = '';
    str += '<h3>'+data.name+'</h3>';
    if (data.street && data.street != "") {
        str += '<p>' + data.street + '</p>'
    }
    if (data.city) {
        str +='<a href="'+data.city+'" class="button buttonSecondary">Více informací</a>';
    }
    return str;
};

web.googlemaps.setMarkerProperties = function(marker, originX) {
    marker.originalData = {
        x: marker.getIcon().origin.x,
        y: marker.getIcon().origin.y,
        url: marker.getIcon().url,
        size: marker.getIcon().size,
        anchor: marker.getIcon().anchor
    };

    var iconProperties = {
        icon: {
            origin: new google.maps.Point(originX, marker.originalData.y),
            url: marker.originalData.url,
            size: marker.originalData.size,
            anchor: marker.originalData.anchor
        }
    };

    marker.setOptions(iconProperties);

};


/**
 * googlemap base setup
 */
$.googlemap.setDefaults({
    mapOptions: {
        startingPosition: {
            lat: 49.897916,
            lng: 15.472708,
            zoom: 8
        },
        mapTypeControl:    false,
        scaleControl:      false,
        panControl:        false,
        streetViewControl: false,
        zoomControl:       false,
        zoomControlOptions: {
            position: google.maps.ControlPosition.LEFT_CENTER
        },
        scrollwheel:       false,
        styles:
            [{"featureType":"administrative.province","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"landscape","elementType":"all","stylers":[{"saturation":-100},{"lightness":60}]},{"featureType":"poi.park","elementType":"geometry.fill","stylers":[{"color":"#4f8c49"},{"lightness":40},{"saturation":-40}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ef8c25"},{"lightness":40}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"labels.icon","stylers":[{"saturation":"-100"},{"lightness":"0"},{"gamma":"1.50"}]},{"featureType":"road.local","elementType":"all","stylers":[{"saturation":-100},{"lightness":40},{"visibility":"on"}]},{"featureType":"road.local","elementType":"labels.icon","stylers":[{"lightness":"0"},{"gamma":"0"}]},{"featureType":"transit","elementType":"all","stylers":[{"saturation":-100},{"visibility":"simplified"}]},{"featureType":"water","elementType":"all","stylers":[{"visibility":"on"},{"lightness":30}]}]
    },
    clustering: {
        enabled: true,
        iconsStyles: [			// [array of objects] - custom cluster icons, there are 5 sizes of cluster icons, define them all, if you use this feature
            {
            	//anchor: [y, x],								// y - position of the number from the top, x - position of the number from the left
				textColor: '#fff',							// color of the number on the groupped marker
				url: '/img/u/googlemap/marker-cluster.png',						// self-explanatory
				height: 38,									// height of the groupped marker
				width: 32,									// width of the groupped marker
				textSize: 18,								// font size of the number
				margin: '-25px 0 0 0'						// set the pointing tip of the marker, originaly is center of the marker.
			}
       	]
    }
    ,
    // Vlastní formát bubliny
    bubbleContentFormatter: function (mData) {
        var str = '';
        if (mData.title) {
            str += '<h3>' + mData.title + '</h3>';
        }
        if (mData.street && mData.street != "") {
            str += '<p>' + mData.street + '</p>';
        }
        if (mData.city) {
            str += '<p>' + mData.city + '</p>';
        }
        return str;
    },
    markerTypes:[
        {
            icon		:	new google.maps.MarkerImage('/img/u/googlemap/markers.png', new google.maps.Size(42,50), new google.maps.Point(0,0), new google.maps.Point(10,45)),
            shadow		:	null,
            shape		:	{
                coords	:		[0,0,41,0,41,36,10,44,0,36],
                type	:		'poly'
            }
        },
        {
            icon		:	new google.maps.MarkerImage('/img/u/googlemap/markers2.png', new google.maps.Size(42,50), new google.maps.Point(0,0), new google.maps.Point(10,45)),
            shadow		:	null,
            shape		:	{
                coords	:		[0,0,41,0,41,41,10,49,0,41],
                type	:		'poly'
            }
        }
    ]
});

function handleSalesmanMap(map, markersData, filter) {

    $(map).googlemap();
    var tempLatitude, tempLongitude, tempZoom;
    //console.log(map.getCenter());
    //console.log(map.center.B);
    map.googlemap('loadMarkers', {
        data: markersData,
        //zoomToMarkersBounds: 0,
        listeners: web.googlemaps.loadMarkersListeners = {
            mouseover: function(e, data, marker) {
                web.googlemaps.setMarkerProperties(marker, 50);
            },
            mouseout: function(e, data, marker) {
                if (!marker.active) {
                    web.googlemaps.setMarkerProperties(marker, 0);
                }
            },
            click: function(e, data, marker) {
                tempLatitude = marker.map.getCenter().lat();
                tempLongitude = marker.map.getCenter().lng();
                tempZoom = marker.map.getZoom();
                var $card = $('.googleMapCard', $(marker.container).parent());
                $(marker.container).googlemap('setCenterAndZoom', {
                    latitude: data.lat,
                    longitude: data.lng,
                    zoom: marker.map.getZoom()
                });

                // build card data
                var str = '<div class="in clearfix sameColsHeight sameColsHeightSm">';
                str += '<div class="googleMapCardSalesman clearfix">';
                str += '<div class="googleMapCardSalesmanLeft">';
                if (data.garantPhoto) {
                    str+= '<img src="' + data.garantPhoto + '" alt="" />';
                }
                str += '</div>';
                str += '<div class="googleMapCardSalesmanRight">';
                if (data.garantPosition) {
                    str+='<h4>' + data.garantPosition + '</h4>';
                }
                str += '<ul class="list-unstyled">';
                if (data.garantName) {
                    str+='<li>' + data.garantName + '</li>';
                }
                if (data.garantEmail) {
                    str+='<li><a href="mailto:' + data.garantEmail + '">' + data.garantEmail + '</a></li>';
                }
                if (data.garantMobile) {
                    str+='<li><span>' + locale['mobile'] + ':</span>' + data.garantMobile + '</li>';
                }
                if (data.garantPhone) {
                    str+='<li><span>' + locale['phone'] + ':</span>' + data.garantPhone + '</li>';
                }
                str += '</ul>';
                str += '</div>';
                str += '</div>';
                str += '<div class="googleMapCardExhibition">';
                str += '<div class="googleMapCardExhibitionName">';
                if (data.name) {
                    str+= '<h3>' + data.name + '</h3>';
                }
                if (data.logo) {
                    str+= '<img src="' + data.logo + '" alt="" />';
                }
                str += '</div>';
                str += '<div class="clearfix">';
                str += '<ul class="list-unstyled googleMapCardExhibitionAddress">';
                if (data.place) {
                    str+= '<li>' + data.place + '</li>';
                }
                if (data.email) {
                    str+= '<li><a href="mailto:' + data.email + '">' + data.email + '</a></li>';
                }
                if (data.web) {
                    str+= '<li><a rel="nofollow" target="_blank" href="' + data.web + '">' + data.web + '</a></li>';
                }
                if (data.phone) {
                    str+= '<li><span>' + locale['phone'] + ':</span>' + data.phone + '</li>';
                }
                if (data.mobile) {
                    str+= '<li><span>' + locale['mobile'] + ':</span>' + data.mobile + '</li>';
                }
                str += '</ul>';
                str += '<div class="clearfix googleMapCardExhibitionContent">';
                if (data.exhibitions) {
                    var exhibitionsImagesStr = '';
                    var exhibitionsProductsStr = '';
                    var captionText = '';
                    for ( var i in data.exhibitions ) {
                        if ( data.exhibitions[i].description ) {
                            captionText += '<strong>' + data.exhibitions[i].name + '</strong>; ' + data.exhibitions[i].description;
                        } else {
                            captionText += '<strong>' + data.exhibitions[i].name + '</strong>';
                        }
                        if (data.exhibitions[i].images) {
                            for ( var j in data.exhibitions[i].images ) {
                                exhibitionsImagesStr += '<li>';
                                exhibitionsImagesStr += '<a href="' + data.exhibitions[i].images[j].exhibitionImageDetail + '" onclick="return hs.expand(this, {slideshowGroup: &quot;gMapGallery' + data.id + '&quot;, captionText: &quot;' + captionText + '&quot;})">';
                                exhibitionsImagesStr += '<img src="' + data.exhibitions[i].images[j].exhibitionImageThumbnail + '" alt="" />';
                                exhibitionsImagesStr += '</a>';
                                exhibitionsImagesStr += '</li>';
                                hs.addSlideshow({ slideshowGroup: 'gMapGallery' + data.id});
                            }
                        }
                        if (data.exhibitions[i].products) {
                            var k = 0;
                            for ( var j in data.exhibitions[i].products ) {
                              if ( k < 2 ) {
                                exhibitionsProductsStr += '<li>';
                                exhibitionsProductsStr += '<a href="' + data.exhibitions[i].products[j].exhibitionProductUrl + '">';
                                exhibitionsProductsStr += data.exhibitions[i].products[j].exhibitionProductName;
                                exhibitionsProductsStr += '</a>';
                                exhibitionsProductsStr += '<span class="colon">,</span>';
                                exhibitionsProductsStr += '</li>';
                              }
                              k++;
                            }
                        }
                    }
                }
                if ( exhibitionsImagesStr != '' ) {
                  str += '<ul class="list-inline googleMapCardExhibitionImages">';
                  str += exhibitionsImagesStr;
                  str += '</ul>';
                }
                if (data.exhibitions.length > 0 && exhibitionsProductsStr != '') {
                str += '<div class="googleMapCardExhibitionProductsCnt">';
                //str += '<h5>' + data.exhibitions[0].name + '</h5>';
                str += '<h5>' + locale['productsExhibitions'] + '</h5>';
                /*str += '<ul class="list-inline googleMapCardExhibitionProducts">';
                str += exhibitionsProductsStr;
                if (data.exhibitions[0].description.length > 0) {
                str += '<li>' + data.exhibitions[0].description + '</li>';
                }
                str += '</ul>';*/
                  if ( data.showMoreExhibitionsLinkStart && data.showMoreExhibitionsLinkEnd) {
                    str += data.showMoreExhibitionsLinkStart;
                    str += locale['exhibitedProducts'];
                    str += data.showMoreExhibitionsLinkEnd;
                  } else if ( data.showMoreExhibitionsLinkStartInProduct && data.showMoreExhibitionsLinkEndInProduct) {
                    str += data.showMoreExhibitionsLinkStartInProduct;
                    str += locale['colorfulCombinationToSee'];
                    str += data.showMoreExhibitionsLinkEndInProduct;
                  }
                str += '</div>';
                } else {
                  if ( data.showMoreExhibitionsLinkStart && data.showMoreExhibitionsLinkEnd) {
                    str += data.showMoreExhibitionsLinkStart;
                    str += locale['companyDetail'];
                    str += data.showMoreExhibitionsLinkEnd;
                  } else if ( data.showMoreExhibitionsLinkStartInProduct && data.showMoreExhibitionsLinkEndInProduct) {
                     str += data.showMoreExhibitionsLinkStartInProduct;
                     str += locale['colorfulCombinationToSee'];
                     str += data.showMoreExhibitionsLinkEndInProduct;
                   }
                }
                str += '</div>';
                str += '</div>';
                str += '<span class="close-card glyphicon glyphicon-basket-delete">Zavřít kartu</span>';
                str += '</div>';
                str += '</div>';
                $card.html(str);
                // show card
                if($card.hasClass('hide-card')) {
                    $card.removeClass('hide-card');
                    //if ( $(window).width > 768 ) {
                        sameColsHeight();
                    //}
                }
                // close card
                $('.close-card', $card).on('click', function(e){
                    e.preventDefault();
                    // inactivate previously activated marker
                    if (web.googlemaps.activeMarker) {
                        web.googlemaps.activeMarker.active = false;
                        var activeMarkerIcon = $.extend(true, {}, web.googlemaps.activeMarker.icon);
                        activeMarkerIcon.origin.x = 0;
                        web.googlemaps.activeMarker.setIcon(activeMarkerIcon);
                        web.googlemaps.activeMarker = null;
                    }
                    // set default position
                    $(marker.container).googlemap('setCenterAndZoom', {
                        latitude: tempLatitude,
                        longitude: tempLongitude,
                        zoom: tempZoom
                    });
                    $card.addClass('hide-card');
                });
                // clicking on inactive marker
                if (!marker.active) {
                    if (web.googlemaps.activeMarker) {
                        web.googlemaps.activeMarker.active = false;
                        var activeMarkerIcon = $.extend(true, {}, web.googlemaps.activeMarker.icon);
                        activeMarkerIcon.origin.x = 0;
                        web.googlemaps.activeMarker.setIcon(activeMarkerIcon);
                        web.googlemaps.activeMarker = null;
                    }
                    marker.active = true;
                    web.googlemaps.activeMarker = marker;
                }
            }
        },
        callback: function () {
            if(this._generatedMarkers.length == 1) {
                var marker = this._generatedMarkers[0],
                    markerData = this._generatedMarkers[0].markerData;
                web.googlemaps.loadMarkersListeners.mouseover.call(this, null, markerData, marker);
                web.googlemaps.loadMarkersListeners.click.call(this, null, markerData, marker);
            }
        }
    });

    if ( filter != null ) {

        if ( filter == 'prodejce' ) {
            toggleSalesman();
            $('#prodejci').addClass('active');
        } else {
            toggleExhibition();
            $('#vystavky').addClass('active');
        }

        $(document).trigger('googleMapLoaded');

    }
}


window.handleSalesmanMap = handleSalesmanMap;

function toggleExhibition() {
    $('.container--map button').removeClass('active');
    $('.googleMapCard').empty().addClass('hide-card');
    $('.googleMapVendorsList').addClass('hide-list');
    $('.googleMapExhibitionsList').removeClass('hide-list');
    $('.map').googlemap('setCenterAndZoom', {
        latitude: 49.897916,
        longitude: 15.472708,
        zoom: 8
    });
    $('.map').googlemap("filterObjects", "markers", {
        kind: ['vystavka']
    }, {}, {
        onMarkerSuccess: function(marker) {
            var newIcon = $.extend(true, {}, marker.icon);
            newIcon.url = '/img/u/googlemap/markers.png';
            marker.setIcon(newIcon);
        }
    });
}

function toggleSalesman() {
    $('.container--map button').removeClass('active');
    $('.googleMapCard').empty().addClass('hide-card');
    $('.googleMapExhibitionsList').addClass('hide-list');
    $('.googleMapVendorsList').removeClass('hide-list');
    $('.map').googlemap('setCenterAndZoom', {
        latitude: 49.897916,
        longitude: 15.472708,
        zoom: 8
    });
    $('.map').googlemap("filterObjects", "markers", {
        kind: ['prodejce']
    }, {}, {
        onMarkerSuccess: function(marker) {
            var newIcon = $.extend(true, {}, marker.icon);
            newIcon.url = '/img/u/googlemap/markers2.png';
            marker.setIcon(newIcon);
        }
    });
}


$(function() {

    $(document).on('change', '.googleMapExhibitionsList select, .googleMapVendorsList select', function() {
        //$('option', this).removeAttr('selected');
        var selectedOption = $('option:selected', this).parent().data('group');
        if ( selectedOption == 'states' ) {
            var country = $('option:selected', this).text();
            var geocoder = new google.maps.Geocoder();
            geocoder.geocode( { 'address': country }, function(results, status) {
                if (status == google.maps.GeocoderStatus.OK) {
                    $('.map').googlemap('setCenterAndZoom', {
                        latitude: results[0].geometry.location.lat(),
                        longitude: results[0].geometry.location.lng(),
                        zoom: 7
                    });
                } else {
                    alert("Could not find location: " + country);
                }
            });
        } else {
            var lat = $('option:selected', this).data('lat');
            var lng = $('option:selected', this).data('lng');
            var zoom = $('option:selected', this).data('zoom');

            $('.map').googlemap('setCenterAndZoom', {
                latitude: lat,
                longitude: lng,
                zoom: zoom
            });

        }
    });

    $(document).on('click', '#vystavky', function() {
        toggleExhibition();
        $(this).addClass('active');
    });

    $(document).on('click', '#prodejci', function() {
        toggleSalesman();
        $(this).addClass('active');
    });

    $('.map').each(function() {
        var hash = window.location.hash;
        if ( hash == '#vystavky') {
            $(document).on('googleMapLoaded', function() {
                toggleExhibition();
                $('#vystavky').addClass('active');
            });
        } else if ( hash == '#prodejci') {
            $(document).on('googleMapLoaded', function() {
                toggleSalesman();
                $('#prodejci').addClass('active');
            });
        }
    });



});

function ZoomControl(controlDiv, map) {

    // Set CSS for the control wrapper
    var controlWrapper = document.createElement('div');
    controlWrapper.classList.add('zoomControlWrapper');
    controlDiv.appendChild(controlWrapper);

    // Set CSS for the zoomIn
    var zoomInButton = document.createElement('div');
    zoomInButton.classList.add('zoomInButton');
    controlWrapper.appendChild(zoomInButton);

    // Set CSS for the zoomOut
    var zoomOutButton = document.createElement('div');
    zoomOutButton.classList.add('zoomOutButton');
    controlWrapper.appendChild(zoomOutButton);

    // Setup the click event listener - zoomIn
    google.maps.event.addDomListener(zoomInButton, 'click', function() {
        map.setZoom(map.getZoom() + 1);
    });

    // Setup the click event listener - zoomOut
    google.maps.event.addDomListener(zoomOutButton, 'click', function() {
        map.setZoom(map.getZoom() - 1);
    });

}

window.ZoomControl = ZoomControl;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/jquery.googlemap.conf.js